<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container small">
          <div class="modal-header">
            <i class="close icon" v-on:click="$emit('close')"></i>
            <h3>{{ title }}</h3>
          </div>

          <div class="ui divider"></div>

          <div class="modal-body scrolling content">
            <p>{{ para }}</p>
            <div class="fields">
              <div class="three wide field">
                <label id="file-upload-label" for="file-upload" class="ui fluid secondary button">Browse</label>
                <input type="file" name="files[]" id="file-upload" multiple :accept="accept" v-on:change="changed($event)">
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <div class="sixteen wide mobile eight wide computer right floated column">
              <a href="#" class="ui basic button smardie-btn-secondary" v-on:click="$emit('close')">Cancel</a>
              <a href="#" class="ui primary button" v-on:click="upload">Upload</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
  export default {
    name: 'FileUpload',
    props: {
      title: {
        type: String
      },
      para: {
        type: String
      },
      url: {
        type: String
      },
      accept: {
        type: String
      }
    },
    data: function () {
      return {
        formData: null
      }
    },
    methods: {
      changed: function (event) {
        let fieldName = event.target.name
        let files = event.target.files
        this.formData = new FormData()
        if (files.length > 0) {
          for (let i = 0; i < files.length; i++) {
            this.formData.append(fieldName, files[i])
          }
        }
      },
      upload: function () {
        if (this.formData) {
          axios.post(this.url, this.formData).then(response => {
            this.successNotification()
          })
        }
      }
    }
  }
</script>

<style scoped>
  #file-upload {
    opacity: 0;
    position: absolute;
    z-index: -1;
  }
</style>
